import { ArrowUpRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";

export const Practice = ({ t, go }) => {
  const p = t.practice;
  return (
    <section id="practice" data-testid="practice-section" className="bg-[#0F2137] py-24 text-white lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-8 border-b border-white/15 pb-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal><Label light>{p.label}</Label></Reveal>
            <Reveal delay={0.1}><h2 className="mt-6 font-serif text-4xl md:text-6xl">{p.title}</h2></Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-4 lg:col-start-9 self-end">
            <p className="text-base leading-relaxed text-slate-300">{p.intro}</p>
          </Reveal>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3">
          {p.items.map((it, i) => (
            <Reveal key={it.t} delay={(i % 3) * 0.08}>
              <button
                data-testid={`practice-area-card-${i}`}
                onClick={() => go("contact")}
                className="practice-card group relative flex h-full w-full flex-col border-b border-white/15 py-10 text-left sm:pr-10"
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
                  <ArrowUpRight size={20} className="text-slate-400 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-white" />
                </div>
                <h3 className="mt-10 font-serif text-2xl md:text-[1.7rem]">{it.t}</h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-300">{it.d}</p>
                <span className="practice-line" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
